document.addEventListener('DOMContentLoaded',()=>{
  // header: scrolled shadow + hamburger
  const header=document.querySelector('[data-site-header]');
  if(header){addEventListener('scroll',()=>header.classList.toggle('scrolled',scrollY>8),{passive:true});}
  const burger=document.querySelector('[data-hamburger]'),mnav=document.querySelector('[data-mobile-nav]');
  burger?.addEventListener('click',()=>{
    const open=mnav.classList.toggle('open');
    burger.setAttribute('aria-expanded',open?'true':'false');
  });
  // cart drawer
  const drawer=document.querySelector('[data-cart-drawer]'),veil=document.querySelector('[data-cart-veil]');
  const open=()=>{drawer?.classList.add('open');veil?.classList.add('open')};
  const close=()=>{drawer?.classList.remove('open');veil?.classList.remove('open')};
  document.querySelectorAll('[data-open-cart]').forEach(b=>b.addEventListener('click',open));
  document.querySelectorAll('[data-close-cart]').forEach(b=>b.addEventListener('click',close));
  veil?.addEventListener('click',close);
  // hero slider — pixel-match to reference: dots + prev/next arrows + 01/03 counter + touch + timer reset
  document.querySelectorAll('[data-slider]').forEach(slider=>{
    const slides=[...slider.querySelectorAll('[data-slide]')];let i=0;
    const dots=[...slider.querySelectorAll('[data-dot]')];
    const num=slider.querySelector('[data-slide-num]');
    const pad=n=>String(n+1).padStart(2,'0');
    const paint=()=>{
      slides.forEach((s,k)=>s.classList.toggle('active',k===i));
      dots.forEach((d,k)=>d.classList.toggle('on',k===i));
      if(num)num.textContent=pad(i)+' / '+pad(slides.length-1);
    };
    let timer=null;
    const start=()=>{if(slides.length>1&&slider.dataset.auto!=='false'){clearInterval(timer);timer=setInterval(()=>{i=(i+1)%slides.length;paint()},6000)}};
    const go=n=>{i=(n+slides.length)%slides.length;paint();start()};
    dots.forEach((d,k)=>d.addEventListener('click',()=>go(k)));
    slider.querySelector('[data-next]')?.addEventListener('click',()=>go(i+1));
    slider.querySelector('[data-prev]')?.addEventListener('click',()=>go(i-1));
    let tx=0;
    slider.addEventListener('touchstart',e=>{tx=e.touches[0].clientX},{passive:true});
    slider.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-tx;if(Math.abs(dx)>48)go(dx<0?i+1:i-1)});
    paint();start();
  });
  // faq + product accordion — delegated so it works with multiple FAQ sections per page + theme editor reloads
  document.addEventListener('click',e=>{
    const q=e.target.closest('[data-faq-q]');
    if(!q)return;
    const item=q.closest('[data-faq-item]');
    if(item)item.classList.toggle('open');
  });
  // product gallery: thumb <-> main swap + variant image sync
  const activateGalMedia=(gal,target)=>{
    if(!gal||target==null)return;
    gal.querySelectorAll('.gal-slide').forEach(s=>s.classList.toggle('is-active',s.dataset.mediaId==target));
    gal.querySelectorAll('.gal-thumb').forEach(t=>{
      const on=t.dataset.target==target;
      t.classList.toggle('on',on);
      if(on){t.setAttribute('aria-current','true');t.scrollIntoView({block:'nearest',inline:'nearest'})}
      else t.removeAttribute('aria-current');
    });
  };
  document.querySelectorAll('[data-gal]').forEach(gal=>{
    gal.querySelectorAll('.gal-thumb').forEach(t=>t.addEventListener('click',()=>activateGalMedia(gal,t.dataset.target)));
  });
  // lightbox modal — opens the clicked media when known, else first
  document.querySelectorAll('modal-opener').forEach(op=>{
    op.addEventListener('click',()=>{
      const m=document.querySelector(op.dataset.modal);
      if(!m)return;
      m.classList.add('open');
      m.querySelectorAll('.es-modal-item').forEach(it=>it.hidden=true);
      const want=op.dataset.modalMedia?m.querySelector(`[data-modal-media-id="${op.dataset.modalMedia}"]`):null;
      (want||m.querySelector('.es-modal-item')).hidden=false;
    });
  });
  document.querySelectorAll('.es-modal').forEach(m=>{
    m.querySelector('.es-modal-close')?.addEventListener('click',()=>m.classList.remove('open'));
    m.addEventListener('click',e=>{if(e.target===m)m.classList.remove('open')});
  });
  // collection grid view toggle (3 / 4 columns)
  document.querySelectorAll('[data-coll-grid]').forEach(grid=>{
    const btns=[...document.querySelectorAll('.view-btn[data-view]')];
    btns.forEach(b=>b.addEventListener('click',()=>{
      btns.forEach(x=>x.classList.remove('on'));b.classList.add('on');
      grid.classList.toggle('cols-4',b.dataset.view==='4');
    }));
  });
  // shop-by-intent carousel: arrows + drag-to-scroll
  document.querySelectorAll('[data-intent]').forEach(sec=>{
    const scroller=sec.querySelector('[data-kitchen-scroll]');
    if(!scroller)return;
    const step=()=> (scroller.querySelector('.es-kitchen-card')?.offsetWidth||320)+18;
    sec.querySelector('[data-kitchen-next]')?.addEventListener('click',()=>scroller.scrollBy({left:step(),behavior:'smooth'}));
    sec.querySelector('[data-kitchen-prev]')?.addEventListener('click',()=>scroller.scrollBy({left:-step(),behavior:'smooth'}));
    let down=false,sx=0,sl=0;
    scroller.addEventListener('pointerdown',e=>{down=true;sx=e.clientX;sl=scroller.scrollLeft;scroller.classList.add('dragging')});
    addEventListener('pointermove',e=>{if(!down)return;scroller.scrollLeft=sl-(e.clientX-sx)});
    addEventListener('pointerup',()=>{down=false;scroller.classList.remove('dragging')});
  });
  // reviews: arrows scroll + product filter pills
  document.querySelectorAll('.reviews-band').forEach(band=>{
    const scroller=band.querySelector('[data-rev-scroll]');
    band.querySelector('[data-rev-prev]')?.addEventListener('click',()=>scroller?.scrollBy({left:-390,behavior:'smooth'}));
    band.querySelector('[data-rev-next]')?.addEventListener('click',()=>scroller?.scrollBy({left:390,behavior:'smooth'}));
    const pills=[...band.querySelectorAll('[data-rev-filter]')];
    pills.forEach(p=>p.addEventListener('click',()=>{
      pills.forEach(x=>x.classList.remove('on'));p.classList.add('on');
      const tag=p.dataset.revFilter;
      band.querySelectorAll('.rev-card').forEach(card=>{
        card.hidden=tag!=='all'&&card.dataset.revTag!==tag;
      });
      scroller?.scrollTo({left:0});
    }));
  });
  // story video: full-square, play/pause + sound on (click button or video)
  document.querySelectorAll('[data-story-frame]').forEach(frame=>{
    const video=frame.querySelector('video');
    const btn=frame.querySelector('[data-story-play]');
    const muteBtn=frame.querySelector('[data-story-mute]');
    const muteLabel=frame.querySelector('[data-story-mute-label]');
    if(!video||!btn)return;
    video.removeAttribute('muted');video.muted=false;video.volume=1;video.loop=false;video.controls=false;
    const sync=()=>{
      frame.classList.toggle('playing',!video.paused);
      frame.classList.toggle('muted',video.muted);
      btn.setAttribute('aria-label',video.paused?'Play video with sound':'Pause video');
      if(muteLabel)muteLabel.textContent=video.muted?'Muted':'Sound on';
    };
    const toggle=e=>{ if(e)e.stopPropagation(); if(video.paused){video.muted=false;video.volume=1;try{const p=video.play();if(p&&p.then)p.then(sync).catch(()=>sync());}catch(err){video.play()} } else {video.pause()} sync(); };
    btn.addEventListener('click',toggle);
    video.addEventListener('click',toggle);
    video.addEventListener('play',sync);video.addEventListener('pause',sync);
    video.addEventListener('ended',sync);
    muteBtn?.addEventListener('click',e=>{e.stopPropagation();video.muted=!video.muted;sync()});
    sync();
  });
  // deferred media (video / 3D poster click)
  document.querySelectorAll('deferred-media .es-poster, product-model .es-poster').forEach(poster=>poster.addEventListener('click',()=>{
    const tpl=poster.parentElement.querySelector('template');
    if(!tpl||poster.parentElement.dataset.loaded)return;
    poster.parentElement.appendChild(tpl.content.cloneNode(true));
    poster.remove();
    poster.parentElement.dataset.loaded='true';
  }));
  document.querySelectorAll('[data-hero-weights]').forEach(row=>{
    const radios=[...row.querySelectorAll('input[type="radio"][name="id"]')];
    const price=row.closest('section')?.querySelector('[data-price-main]');
    const paint=()=>{
      radios.forEach(r=>{
        const label=r.closest('[data-pill-label]');
        if(label)label.style.borderColor=r.checked?'var(--ink)':'';
      });
    };
    radios.forEach(r=>r.addEventListener('change',()=>{
      paint();
      if(price&&r.dataset.wp)price.textContent='₹'+r.dataset.wp;
      if(r.dataset.mediaId)activateGalMedia(document.querySelector('[data-gal]'),r.dataset.mediaId);
    }));
    paint();
  });
  document.querySelectorAll('[data-qty]').forEach(btn=>btn.addEventListener('click',()=>{
    const wrap=btn.parentElement;const val=wrap.querySelector('[data-qty-val]');
    const input=wrap.parentElement.querySelector('[data-qty-input]')||btn.closest('form')?.querySelector('[data-qty-input]');
    let n=parseInt(val.textContent||'1',10)+(btn.dataset.qty==='+'?1:-1);
    n=Math.max(1,n);val.textContent=n;if(input)input.value=n;
  }));
  const sticky=document.querySelector('[data-sticky-bar]');
  if(sticky){addEventListener('scroll',()=>{
    const show=scrollY>700;sticky.style.display=show?'flex':'none';
  },{passive:true});}
  // product card weight pills → switch variant + price (like original w-btn behaviour)
  document.querySelectorAll('[data-card]').forEach(card=>{
    const btns=[...card.querySelectorAll('[data-weight-row] .w-btn')];
    const input=card.querySelector('[data-variant-input]');
    const priceNow=card.querySelector('[data-price-now]');
    btns.forEach(b=>b.addEventListener('click',()=>{
      btns.forEach(x=>x.classList.remove('on'));b.classList.add('on');
      if(input)input.value=b.dataset.variantId;
      if(priceNow&&b.dataset.price)priceNow.textContent='₹'+b.dataset.price;
    }));
  });
  // recipe article: serving scaler + ingredient check + step done + print/share (scoped to [data-recipe])
  document.querySelectorAll('[data-recipe]').forEach(root=>{
    const base=parseFloat(root.dataset.baseServings||'4',10)||4;
    let cur=base;
    const valEls=root.querySelectorAll('[data-rp-serv-val]');
    const dispEls=root.querySelectorAll('[data-rp-serv-display]');
    const countEls=root.querySelectorAll('[data-rp-ing-count]');
    const paint=()=>{
      valEls.forEach(el=>el.textContent=cur);
      dispEls.forEach(el=>el.textContent=cur);
      countEls.forEach(el=>el.textContent=cur);
      root.querySelectorAll('.rp-ing-qty[data-base]').forEach(el=>{
        const b=parseFloat(el.dataset.base);
        if(!b)return;
        const scaled=b*cur/base;
        const num=scaled%1===0?scaled:Math.round(scaled*10)/10;
        const unit=el.dataset.unit?(' '+el.dataset.unit):'';
        el.textContent=num+unit;
      });
    };
    root.querySelector('[data-rp-minus]')?.addEventListener('click',()=>{cur=Math.max(1,Math.min(20,cur-1));paint()});
    root.querySelector('[data-rp-plus]')?.addEventListener('click',()=>{cur=Math.max(1,Math.min(20,cur+1));paint()});
    root.querySelectorAll('[data-rp-ing]').forEach(li=>li.addEventListener('click',()=>li.classList.toggle('checked')));
    root.querySelectorAll('[data-rp-done]').forEach(btn=>btn.addEventListener('click',()=>{
      const step=btn.closest('[data-rp-step]');
      if(!step)return;
      const done=step.classList.toggle('done');
      step.classList.toggle('active',done);
      step.style.opacity=done?'0.72':'1';
      btn.querySelector('span').textContent=done?'Done!':'Mark done';
      if(done){
        let next=step.nextElementSibling;
        while(next&&!next.hasAttribute('data-rp-step'))next=next.nextElementSibling;
        if(next){next.scrollIntoView({behavior:'smooth',block:'center'});next.classList.add('active');setTimeout(()=>{if(!next.classList.contains('done'))next.classList.remove('active')},1800)}
      }
    }));
    root.querySelector('[data-rp-print]')?.addEventListener('click',()=>window.print());
    root.querySelector('[data-rp-share]')?.addEventListener('click',async()=>{
      const url=location.href;
      try{await navigator.clipboard.writeText(url)}catch(e){/* clipboard unavailable */}
      const toast=root.querySelector('[data-rp-toast]');
      const msg=root.querySelector('[data-rp-toast-msg]');
      if(toast&&msg){
        msg.textContent='Link copied to clipboard!';
        toast.classList.add('show');
        clearTimeout(root._rpToast);
        root._rpToast=setTimeout(()=>toast.classList.remove('show'),2200);
      }
    });
    root.querySelector('[data-rp-rate]')?.addEventListener('click',()=>{
      document.getElementById('instructions')?.scrollIntoView({behavior:'smooth'});
    });
  });
  // recipes archive: category tabs + live search + load more (scoped)
  document.querySelectorAll('[data-recipes-archive]').forEach(root=>{
    const cards=[...root.querySelectorAll('[data-ra-card]')];
    const tabs=[...root.querySelectorAll('[data-ra-tabs] .hero-tab')];
    const search=root.querySelector('[data-ra-search]');
    const more=root.querySelector('[data-ra-more]');
    const empty=root.querySelector('[data-ra-empty]');
    const total=root.querySelector('[data-ra-total]');
    let filter='all',q='',shown=6;
    const PAGE=6;
    const match=card=>{
      const okF=filter==='all'||card.dataset.category===filter;
      if(!okF)return false;
      if(!q)return true;
      const text=(card.textContent||'').toLowerCase();
      return text.includes(q);
    };
    const paint=()=>{
      const vis=cards.filter(match);
      cards.forEach(c=>c.style.display='none');
      vis.slice(0,shown).forEach(c=>c.style.display='');
      if(empty)empty.hidden=vis.length>0;
      if(more)more.style.display=vis.length>shown?'inline-flex':'none';
    };
    tabs.forEach(t=>t.addEventListener('click',()=>{
      tabs.forEach(x=>x.classList.remove('on'));t.classList.add('on');
      filter=t.dataset.filter||'all';shown=PAGE;paint();
    }));
    search?.addEventListener('input',()=>{q=search.value.toLowerCase().trim();shown=PAGE;paint()});
    more?.addEventListener('click',()=>{shown+=PAGE;paint()});
    if(total&&!total.textContent.trim())total.textContent=cards.length;
    paint();
  });
  // ajax add
  document.querySelectorAll('[data-add-to-cart]').forEach(form=>{
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const fd=new FormData(form);
      await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});
      const c=await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=c.item_count);
      open();
      const items=document.querySelector('[data-cart-items]');
      if(items)items.innerHTML=c.items.map(it=>`<div class="c-item"><div><div class="c-item-name">${it.product_title}</div><div class="c-item-wt">${it.variant_title||''} × ${it.quantity}</div></div><div>${(it.final_line_price/100).toFixed(0)}</div></div>`).join('')||'<p>Your cart is empty</p>';
    });
  });
});
